import EmptyIcon from '@assets/icons/empty-state.svg';

import { EmptyDescWrapper, EmptyTitleWrapper, EmptyWrapper } from './styled.tsx';

export const EmptyResult = ({
    title,
    description,
    bgColor,
}: {
    title: string;
    description: string;
    bgColor?: string;
}) => {
    return (
        <EmptyWrapper data-cy="empty-result" $bgColor={bgColor}>
            <EmptyIcon />
            <EmptyTitleWrapper>{title}</EmptyTitleWrapper>
            <EmptyDescWrapper>{description}</EmptyDescWrapper>
        </EmptyWrapper>
    );
};
